<template>
	<div>
		<!-- dialog -->
		<v-dialog v-model="dialog" max-width="400">
			<v-form ref="form" @submit.prevent="submit">
				<v-card>
					<v-card-title class="primary--text">
						<v-btn icon @click="dialog = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
				
						<v-spacer/>
						<span class="me-8">
							{{ !messageId ? $t('QuickMessages.add-message') : $t('QuickMessages.edit-message')}}
						</span>
						<v-spacer/>
					</v-card-title>
					<v-card-text class="pb-2">
						<v-textarea
							v-model="message"
							label="الرسالة"
							rows="2"
							dense
							outlined
							rounded
							auto-grow
							hide-details
							:rules="rules.required"
						/>
					</v-card-text>
					<v-card-actions class="justify-end">
						<v-btn
							type="submit"
							color="primary"
							:loading="submitLoading"
						>
							{{$t('save')}}
						</v-btn>
						<v-btn @click="dialog = false">
							{{$t('cancel')}}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>

		<!-- delete dialog -->
		<v-dialog v-model="deleteDialog" max-width="300">
			<v-form @submit.prevent="deleteMessage">
				<v-card>
					<v-card-title class="error--text">
						<v-btn icon @click="deleteDialog = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
				
						<v-spacer/>
						<span class="me-8">
							حذف الرسالة
						</span>
						<v-spacer/>
					</v-card-title>
					<v-card-text class="pb-2">
						هل انت متأكد من حذف الرسالة؟
					</v-card-text>
					<v-card-actions class="justify-end">
						<v-btn
							type="submit"
							color="error"
							:loading="deleteLoading"
						>
							{{$t('delete')}}
						</v-btn>
						<v-btn @click="deleteDialog = false">
							{{$t('cancel')}}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>

		<!-- quick message -->
        <v-dialog v-model="dialogMessage" width="350">
            <v-card>
                <v-card-title class="d-flex  pb-0">
                    <v-btn icon :disabled="loading || submitLoading" color="primary" @click="dialogMessage = false">
                        <v-icon> mdi-close </v-icon>
                    </v-btn>

					<v-spacer />
                    
					<span>
                        {{ $t('QuickMessages.send-message') }}
                    </span>

					<v-spacer />
					<v-spacer />
                </v-card-title>
                <v-card-text>
                    <v-row class="mt-1 px-2">
						<!-- vehicle -->
						<v-col cols="12" align-self="center" class="pa-1">
							<v-autocomplete
								v-model="vehicleId"
								:label="$t('inputs.vehicle-no')"
								:items="vehicles"
								item-text="BusNo"
								item-value="Id"
								dense
								hide-details
								outlined
								:disabled="submitLoading"
								@change="vehicleId !== null ? getStudentInVehicles() : null"
								autofocus
							></v-autocomplete>
						</v-col>
                        <v-col cols="12" align-self="center" class="pa-1">
                            <v-autocomplete
                                v-model="studentIds"
                                :items="studentInVehicle"
                                :item-text="(item) => `${item.FirstName} ${item.LastName}`"
                                item-value="AccountId"
                                outlined
                                dense
                                :label="$t('inputs.student-name')"
                                hide-details
                                class="rounded-BigLg"
                                :disabled="loading || loadingGetStudent"
                                multiple
                                clearable
								:loading="loadingGetStudent"
                            >
                                <template v-slot:prepend-item>
                                    <v-list-item
                                        ripple
                                        @click="toggle"
                                    >
                                        <v-list-item-action>
                                            <v-icon>
                                                {{ icon }}
                                            </v-icon>
                                        </v-list-item-action>

                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{ $t('select-all') }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>
                                <template v-slot:selection="{ item, index }">
                                    <span v-if="index === 0" class="me-1">{{ item.FirstName }} {{ item.LastName }}</span>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                        (+{{ studentIds.length - 1 }})
                                    </span>
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" align-self="center" class="pa-1">
                            <!-- messages -->
                            <v-autocomplete
                                v-model="quickMessage"
                                :items="quickMessages"
                                item-text="Message"
                                item-value="ID"
                                outlined
                                dense
                                :label="$t('inputs.message')"
                                hide-details
                                class="rounded-BigLg"
                                height="100"
                                :loading="loading"
                                clearable
                                :disabled="loading"
                            />
                        </v-col>

                        <v-col cols="12" class="py-1">
                            <v-btn
                                color="primary"
                                class="rounded-BigLg"
                                width="100%"
                                @click="sendQuickMessage()"
								:disabled="submitLoading || !quickMessage || studentIds.length === 0"
                            >
                                {{ $t('send') }}
                                <v-icon size="10" class="mx-1"> mdi-send </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

		<!-- add -->
		<div class="text-end mb-2">
			<v-btn color="primary" @click="dialog = true">
				{{$t('QuickMessages.add-message')}}
			</v-btn>

			<v-btn color="primary" class="mx-2" @click="dialogMessage = true">
				{{$t('QuickMessages.send-message')}}
			</v-btn>
		</div>

		<!-- table -->
		<v-data-table
			:headers="headers"
			:items="!loading ? quickMessages : []"
			:loading="loading"
			:items-per-page="50"
			dense
			:footer-props="{
				'items-per-page-options': [20, 50, 100, -1],
			}"
			:height="$vuetify.breakpoint.height - 190"
			class="elevation-2"
			disable-sort
		>
			<template v-slot:item.actions="{ item }">
				<div class="d-flex">
					<!-- edit -->
					<v-tooltip top>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								depressed
								height="30"
								width="30"
								min-width="30"
								class="my-1"
								color="purple lighten-4 primary--text"
								v-on="on"
								v-bind="attrs"
								@click="messageId = item.ID; dialog = true;"
							>
								<v-icon>mdi-pencil</v-icon>
							</v-btn>
						</template>
					
						{{$t('edit')}}
					</v-tooltip>
					
					<!-- delete -->
					<v-tooltip top>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								depressed
								height="30"
								width="30"
								min-width="30"
								class="my-1"
								color="error lighten-4 error--text ms-1"
								v-on="on"
								v-bind="attrs"
								@click="deleteId = item.ID; deleteDialog = true;"
							>
								<v-icon>mdi-delete</v-icon>
							</v-btn>
						</template>
					
						{{$t('delete')}}
					</v-tooltip>
				</div>
			</template>
		</v-data-table>
	</div>
</template>

<script>
import rules from '@/helpers/validation rules';
import { mapGetters, mapState } from 'vuex';
export default {
	name: 'QuickMessages',

	data() {
		return {
			rules,

			dialog: false,
			loading: false,

			deleteDialog: false,
			deleteId: null,
			deleteLoading: false,

			submitLoading: false,

			// data
			messageId: null,
			message: null,
			// message dialog
			dialogMessage: false,
			studentIds: [],
			quickMessage: null,
			vehicleId: null,
			studentInVehicle: [],
			loadingGetStudent: false
		}
	},

	watch: {
		dialog(val) {
			if (val) {
				if (this.messageId) {
					this.message = this.getQuickMessageById(this.messageId)?.Message;
				}
			} else {
				this.$refs.form.reset();
				this.messageId = null;
			}
		},
		dialogMessage (val) {
			if (!val) {
				this.vehicleId = null
				this.studentIds = []
				this.quickMessage = null
			}
		}
	},

	computed: {
		...mapState({
			quickMessages: state => state.quickMessages.quickMessages,
			vehicles: state => state.vehicles.vehicles
		}),

		...mapGetters({
			getQuickMessageById: 'quickMessages/getQuickMessageById'
		}),

		headers() {
			return [
				{
					text: this.$t('headers.message'),
					value: 'Message',
				},
				{
					text: '',
					value: 'actions',
					width: 40
				},
			]
		},

		icon () {
			if (this.studentIds.length === this.studentInVehicle.length) return 'mdi-close-box'
			return 'mdi-checkbox-blank-outline'
		}
	},

	methods: {
		fetchQuickMessages() {
			this.loading = true;
			this.$store.dispatch('quickMessages/fetchAll').then(() => {
				this.loading = false;
			});
		},
		
		submit() {
			if (this.$refs.form.validate()) {
				this.submitLoading = true;
				const actionName = !this.messageId ? 'create' : 'update';
				this.$store.dispatch(`quickMessages/${actionName}`, {
					id: this.messageId,
					message: this.message,
				}).then(() => {
					this.dialog = false;
					this.$eventBus.$emit('show-snackbar', 'info', this.$t('messages.saved-successfully'))
					this.fetchQuickMessages();
				}).finally(() => {
					this.submitLoading = false;
				});
			}
		},

		deleteMessage() {
			this.deleteLoading = true;
			this.$store.dispatch('quickMessages/delete', { id: this.deleteId }).then(() => {
				this.deleteDialog = false;
				this.$eventBus.$emit('show-snackbar', 'info', this.$t('messages.deleted-successfully'))
				this.fetchQuickMessages();
			}).finally(() => {
				this.deleteLoading = false;
			});
		},

		sendQuickMessage () {
			this.submitLoading = true
			this.$store.dispatch('quickMessages/sendMessage', {
				AccountIds: this.studentIds,
				QuickMessageId: this.quickMessage,
				BusId: this.vehicleId,
			}).then(() => {
				this.dialogMessage = false;
				this.$eventBus.$emit('show-snackbar', 'info', this.$t('messages.message-sent-successfully'))
			}).finally(() => {
				this.submitLoading = false
			})
		},
		
		getStudentInVehicles () {
			this.loadingGetStudent = true
			this.$store.dispatch('passengers/getStudentInVehicles', {
				busId: this.vehicleId,
			}).then((data) => {
				this.studentInVehicle = data
			}).finally(() => {
				this.loadingGetStudent = false
			})
		},

		toggle () {
			this.$nextTick(() => {
				if (this.studentIds.length === this.studentInVehicle.length) {
					this.studentIds = []
				} else {
					this.studentIds = this.studentInVehicle.map(c => c.id)
					this.setStudent()
				}
			})
		},

		setStudent () {
			this.studentIds = []
			if (!this.studentInVehicle) return
			this.studentInVehicle.forEach(student => {
				this.studentIds.push(student.AccountId)
			})
		},
	},

	created() {
		if (!this.quickMessages.length) {
			this.fetchQuickMessages();
		}
		if (!this.vehicles.length) {
			this.$store.dispatch('vehicles/fetchAll')
		}
	}
};
</script>

<style>
</style>